export default __webpack_public_path__ + "static/media/send-icon.3a0e9ae1.svg";